"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatMessagesContext = void 0;
const react_1 = require("react");
exports.ChatMessagesContext = (0, react_1.createContext)({});
